import { Layout, Page } from "@fdoh/health-ui-react";
import { useRef } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
//import ApplicationDetailsPage from "../../components/ApplicationDetails";
import FilledMoundSystemInspectionForm from "../Components/FilledMoundSystemForm";
import { FilledMoundSystemInspectionInput } from "../Components/FilledMoundSystemForm.types";
import ApplicationDetailsPage from "../Components/Home/ApplicationDetails";
//import FilledMoundSystemInspectionForm from "../Components/FilledMoundSystemInspectionForm";


// TODO: Add error handling

const CreateFilledMoundSystemPage = () => {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
    const applicationId = JSON.parse(searchParams.get("applicationId") || '{}');
    const inspectionId = JSON.parse(searchParams.get("inspectionId") || '{}');

  return applicationId ? (
   
    <Page.Container>
          <ApplicationDetailsPage id={parseInt(applicationId)}></ApplicationDetailsPage>     
      <Page.Body>
        <Layout.Container>
                  <FilledMoundSystemInspectionForm
                      id="createFilledMoundSystemFormInspectionForm"
                      title="Filled/Mound System Inspection"
                      action="post"
                      applicationId={applicationId ? applicationId : 0}
                      applicationInspectionId={inspectionId ? inspectionId : 0}
                      returnPath={`/inspectionDetails/${inspectionId}`}
                     // values={createSelectInput}
          />
        </Layout.Container>
      </Page.Body>
    </Page.Container>
  ):
  <div>
    
  </div>;
};

export default CreateFilledMoundSystemPage;